export default "__VITE_ASSET__05b98665__"